import styled from 'styled-components';
import { rem, ellipsis } from 'polished';
import BoxEmployee from '../BoxEmployee';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import DateFormat from '../DateFormat';
import Icon from '../Icon';

const StyledEducation = styled(BoxEmployee)`
  ${mediaqueries.greaterThan('desktop')`
    height: auto;
    padding: ${rem('26px')} ${rem('60px')};
  `};
`;

const StyledList = styled.ul`
  margin: 0;
  padding: 0;
`;

const StyledElements = styled.li`
  line-height: ${rem('20px')};
  margin-bottom: ${rem('10px')};
  padding-left: ${rem('13px')};
  :before {
    background-color: ${props => props.theme.colors.dark};
  }
  ${mediaqueries.greaterThan('mobile')`
    display: flex;
  `};
  ${mediaqueries.greaterThan('desktop')`
    flex-direction: column;
  `};
`;

const StyledBatch = styled.div`
  ${mediaqueries.greaterThan('mobile')`
    width: 50%;
  `};
  ${mediaqueries.greaterThan('desktop')`
    display: flex;
    width: 100%;
  `};
`;

const StyledCertificate = styled.h4`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('18px')};
  margin: 0;
  padding-top: ${rem('5px')};
  ${mediaqueries.greaterThan('mobile')`
    padding-right: ${rem('15px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    line-height: ${rem('24px')};
    font-size: ${props => props.theme.fontSize.medium};
    padding-top: ${rem('2px')};
    width: 100%;
    ${ellipsis('100%')};
  `};
`;

const StyledParagraph = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  margin: 0;
  ${mediaqueries.greaterThan('mobile')`
    padding-top: ${rem('4px')};
    width: 50%;
  `};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.medium};
    padding: 0 ${rem('15px')} 0 0;
    width: calc(100% - ${rem('76px')});
    ${ellipsis('100%')};
  `};
`;

const StyledBetweenDay = styled(DateFormat)`
  font-size: ${props => props.theme.fontSize.small};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.medium};
    margin-top:${rem('3px')}
  `};
`;

const StyledDash = styled.span`
  margin: ${rem('2px')};
`;

const StyleEditIcon = styled(Icon)`
  position: absolute;
  top: 10px;
  right: 10px;
`;

export {
  StyledEducation,
  StyledList,
  StyledElements,
  StyledBatch,
  StyledCertificate,
  StyledParagraph,
  StyledBetweenDay,
  StyledDash,
  StyleEditIcon
};
